import CommuneModel from '@/models/General/GCommune'

const fetchCommunes = async function(){
    try{
        let communes = await CommuneModel.params({
            get_all_results : true
        }).get()
        return communes.data
    }
    catch(error){
        return error.response.data
    }
}

export default {
    fetchCommunes
}